import { H4, P4, styled, withStyle } from '@olxeu-jobs/ui';
import { Platform } from '~types';

export const LayoutWrapper = styled('div', {
  overflow: 'hidden',
  textDecoration: 'none',
});

export const HeaderWrapper = styled('div', { position: 'relative', aspectRatio: '2/1' });

export const ContentWrapper = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: $theme.space[8],
  paddingRight: $theme.space[8],
  paddingBottom: $theme.space[8],
  paddingLeft: $theme.space[8],
  backgroundColor: $theme.colors['background-global-primary'],
  borderBottomLeftRadius: $theme.radii[4],
  borderBottomRightRadius: $theme.radii[4],
  minHeight: '60px',

  ...($theme.platform === Platform.DESKTOP && {
    minHeight: '76px',
    paddingTop: $theme.space[16],
    paddingRight: $theme.space[16],
    paddingBottom: $theme.space[16],
    paddingLeft: $theme.space[16],
  }),
}));

export const Title = withStyle(H4, ({ $theme }) => ({
  width: '100%',
  marginBottom: $theme.space[8],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const Industry = withStyle(P4, {
  display: 'inline-flex',
  alignItems: 'center',
  width: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  marginTop: 0,
  marginBottom: 0,
});

export const IndustryTitle = styled('strong', ({ $theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  paddingLeft: $theme.space[4],
}));

export const Divider = styled('div', ({ $theme }) => ({
  width: '100%',
  border: `1px solid ${$theme.colors['borders-global-tertiary']}`,
  marginTop: $theme.space[16],
  marginRight: 0,
  marginBottom: $theme.space[16],
  marginLeft: 0,
}));

export const LogoWrapper = styled('div', ({ $theme }) => ({
  boxSizing: 'content-box',
  position: 'absolute',
  right: $theme.space[16],
  bottom: `-${$theme.space[12]}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '80px',
  aspectRatio: '4/3',
  backgroundColor: $theme.colors['background-global-primary'],
  overflow: 'hidden',
  border: `1px solid ${$theme.colors['borders-global-tertiary']}`,
  borderRadius: $theme.radii[4],
}));

export const LoaderWrapper = styled('div', {
  position: 'relative',
  flex: 1,
});
